import { gql } from 'graphql-tag';
export const PRODUCTPUBLISHSETTING_FIELDS_FRAGMENT = gql `
  fragment ProductPublishSettingFields on ProductPublishSetting {
    scope
    activateOnAccept
    publishOnlineOnAccept
  }
`;
export const SELLERLOCATIONSETTING_FIELDS_FRAGMENT = gql `
  fragment SellerLocationSettingFields on SellerLocationSetting {
    scope
    hideSelectCountryIfSingleCountry
    sellerLocationOption
    allowedCountries
  }
`;
export const PRODUCTSHIPPINGSETTING_FIELDS_FRAGMENT = gql `
  fragment ProductShippingSettingFields on ProductShippingSetting {
    scope
    allowProfiles
    inlineShippingOptions
    shippingCountryOfOriginOption
    customShippingCountryOfOriginList
    hideSelectCountryIfSingleCountry
    allowAllInternationalShippingCountries
    allowedInternationalShippingCountries
  }
`;
export const PRODUCTTYPESETTING_FIELDS_FRAGMENT = gql `
  fragment ProductTypeSettingFields on ProductTypeSetting {
    scope
    productType
  }
`;
export const STOREFRONTSETTING_FIELDS_FRAGMENT = gql `
  fragment StorefrontSettingFields on StorefrontSetting {
    scope
    enabled
    storefrontOptions {
      allowNotification
      allowBanner
      allowStory
      allowOwnerBio
      allowReviews
      allowMessaging
    }
  }
`;
export const SELLERORDERACCEPTSETTING_FIELDS_FRAGMENT = gql `
  fragment SellerOrderAcceptSettingFields on SellerOrderAcceptSetting {
    scope
    autoAccept
    orderAcceptTimeout
  }
`;
export const SELLERORDERFEESETTING_FIELDS_FRAGMENT = gql `
  fragment SellerOrderFeeSettingFields on SellerOrderFeeSetting {
    scope
    orderFee
  }
`;
export const SELLERORDERFULFILLEDSETTING_FIELDS_FRAGMENT = gql `
  fragment SellerOrderFulfilledSettingFields on SellerOrderFulfilledSetting {
    scope
    autoFulfilled
    orderFulfilledTimeout
  }
`;
export const PAYOUTPERIODSETTING_FIELDS_FRAGMENT = gql `
  fragment PayoutPeriodSettingFields on PayoutPeriodSetting {
    scope
    payoutPeriod
    payoutPeriodChoice
  }
`;
export const PRODUCTFEESETTING_FIELDS_FRAGMENT = gql `
  fragment ProductFeeSettingFields on ProductFeeSetting {
    scope
    productFee
  }
`;
export const PRODUCTPERCENTAGESETTING_FIELDS_FRAGMENT = gql `
  fragment ProductPercentageSettingFields on ProductPercentageSetting {
    scope
    productPercentage
  }
`;
export const RETURNSSETTING_FIELDS_FRAGMENT = gql `
  fragment ReturnsSettingFields on ReturnsSetting {
    scope
    noReturns
    returnsTimeout
  }
`;
export const SHIPPINGPERCENTAGESETTING_FIELDS_FRAGMENT = gql `
  fragment ShippingPercentageSettingFields on ShippingPercentageSetting {
    scope
    shippingPercentage
  }
`;
export const PRODUCTREVIEWSETTING_FIELDS_FRAGMENT = gql `
  fragment ProductReviewSettingFields on ProductReviewSetting {
    scope
    reviewAction
  }
`;
export const DEDUCTIONSSETTING_FIELDS_FRAGMENT = gql `
  fragment DeductionsSettingFields on DeductionsSetting {
    scope
    deductions {
      name
      type
      amount
    }
  }
`;
export const COMMISSIONBASISSETTING_FIELDS_FRAGMENT = gql `
  fragment CommissionBasisSettingFields on CommissionBasisSetting {
    scope
    basis
    showSellerCost
  }
`;
export const SETTINGS_FRAGMENT = gql `
  fragment SettingsFragment on ShopSettings {
    productPublish {
      ...ProductPublishSettingFields
    }
    sellerLocation {
      ...SellerLocationSettingFields
    }
    productShipping {
      ...ProductShippingSettingFields
    }
    productType {
      ...ProductTypeSettingFields
    }
    storefront {
      ...StorefrontSettingFields
    }
    sellerOrderAccept {
      ...SellerOrderAcceptSettingFields
    }
    orderFee {
      ...SellerOrderFeeSettingFields
    }
    sellerOrderFulfilled {
      ...SellerOrderFulfilledSettingFields
    }
    payoutPeriod {
      ...PayoutPeriodSettingFields
    }
    productFee {
      ...ProductFeeSettingFields
    }
    productPercentage {
      ...ProductPercentageSettingFields
    }
    returns {
      ...ReturnsSettingFields
    }
    shippingPercentage {
      ...ShippingPercentageSettingFields
    }
    productReview {
      ...ProductReviewSettingFields
    }
    deductions {
      ...DeductionsSettingFields
    }
    commissionBasis {
      ...CommissionBasisSettingFields
    }
  }
  ${PRODUCTPUBLISHSETTING_FIELDS_FRAGMENT}
  ${SELLERLOCATIONSETTING_FIELDS_FRAGMENT}
  ${PRODUCTSHIPPINGSETTING_FIELDS_FRAGMENT}
  ${PRODUCTTYPESETTING_FIELDS_FRAGMENT}
  ${STOREFRONTSETTING_FIELDS_FRAGMENT}
  ${SELLERORDERACCEPTSETTING_FIELDS_FRAGMENT}
  ${SELLERORDERFEESETTING_FIELDS_FRAGMENT}
  ${SELLERORDERFULFILLEDSETTING_FIELDS_FRAGMENT}
  ${PAYOUTPERIODSETTING_FIELDS_FRAGMENT}
  ${PRODUCTFEESETTING_FIELDS_FRAGMENT}
  ${PRODUCTPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${RETURNSSETTING_FIELDS_FRAGMENT}
  ${SHIPPINGPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${PRODUCTREVIEWSETTING_FIELDS_FRAGMENT}
  ${DEDUCTIONSSETTING_FIELDS_FRAGMENT}
  ${COMMISSIONBASISSETTING_FIELDS_FRAGMENT}
`;
export const SELLER_SETTINGS_FRAGMENT = gql `
  fragment SellerSettingsFragment on SellerSettings {
    productPublish {
      current {
        ...ProductPublishSettingFields
      }
      fallback {
        ...ProductPublishSettingFields
      }
    }
    sellerLocation {
      current {
        ...SellerLocationSettingFields
      }
      fallback {
        ...SellerLocationSettingFields
      }
    }
    productShipping {
      current {
        ...ProductShippingSettingFields
      }
      fallback {
        ...ProductShippingSettingFields
      }
    }
    productType {
      current {
        ...ProductTypeSettingFields
      }
      fallback {
        ...ProductTypeSettingFields
      }
    }
    storefront {
      current {
        ...StorefrontSettingFields
      }
      fallback {
        ...StorefrontSettingFields
      }
    }
    sellerOrderAccept {
      current {
        ...SellerOrderAcceptSettingFields
      }
      fallback {
        ...SellerOrderAcceptSettingFields
      }
    }
    orderFee {
      current {
        ...SellerOrderFeeSettingFields
      }
      fallback {
        ...SellerOrderFeeSettingFields
      }
    }
    sellerOrderFulfilled {
      current {
        ...SellerOrderFulfilledSettingFields
      }
      fallback {
        ...SellerOrderFulfilledSettingFields
      }
    }
    payoutPeriod {
      current {
        ...PayoutPeriodSettingFields
      }
      fallback {
        ...PayoutPeriodSettingFields
      }
    }
    productFee {
      current {
        ...ProductFeeSettingFields
      }
      fallback {
        ...ProductFeeSettingFields
      }
    }
    productPercentage {
      current {
        ...ProductPercentageSettingFields
      }
      fallback {
        ...ProductPercentageSettingFields
      }
    }
    returns {
      current {
        ...ReturnsSettingFields
      }
      fallback {
        ...ReturnsSettingFields
      }
    }
    shippingPercentage {
      current {
        ...ShippingPercentageSettingFields
      }
      fallback {
        ...ShippingPercentageSettingFields
      }
    }
    productReview {
      current {
        ...ProductReviewSettingFields
      }
      fallback {
        ...ProductReviewSettingFields
      }
    }
    deductions {
      current {
        ...DeductionsSettingFields
      }
      fallback {
        ...DeductionsSettingFields
      }
    }
    commissionBasis {
      current {
        ...CommissionBasisSettingFields
      }
      fallback {
        ...CommissionBasisSettingFields
      }
    }
  }
  ${PRODUCTPUBLISHSETTING_FIELDS_FRAGMENT}
  ${SELLERLOCATIONSETTING_FIELDS_FRAGMENT}
  ${PRODUCTSHIPPINGSETTING_FIELDS_FRAGMENT}
  ${PRODUCTTYPESETTING_FIELDS_FRAGMENT}
  ${STOREFRONTSETTING_FIELDS_FRAGMENT}
  ${SELLERORDERACCEPTSETTING_FIELDS_FRAGMENT}
  ${SELLERORDERFEESETTING_FIELDS_FRAGMENT}
  ${SELLERORDERFULFILLEDSETTING_FIELDS_FRAGMENT}
  ${PAYOUTPERIODSETTING_FIELDS_FRAGMENT}
  ${PRODUCTFEESETTING_FIELDS_FRAGMENT}
  ${PRODUCTPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${RETURNSSETTING_FIELDS_FRAGMENT}
  ${SHIPPINGPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${PRODUCTREVIEWSETTING_FIELDS_FRAGMENT}
  ${DEDUCTIONSSETTING_FIELDS_FRAGMENT}
  ${COMMISSIONBASISSETTING_FIELDS_FRAGMENT}
`;
export const PRODUCT_SETTINGS_FRAGMENT = gql `
  fragment ProductSettingsFragment on ProductSettings {
    productFee {
      current {
        ...ProductFeeSettingFields
      }
      fallback {
        ...ProductFeeSettingFields
      }
    }
    productPercentage {
      current {
        ...ProductPercentageSettingFields
      }
      fallback {
        ...ProductPercentageSettingFields
      }
    }
    returns {
      current {
        ...ReturnsSettingFields
      }
      fallback {
        ...ReturnsSettingFields
      }
    }
    shippingPercentage {
      current {
        ...ShippingPercentageSettingFields
      }
      fallback {
        ...ShippingPercentageSettingFields
      }
    }
    productReview {
      current {
        ...ProductReviewSettingFields
      }
      fallback {
        ...ProductReviewSettingFields
      }
    }
    commissionBasis {
      current {
        ...CommissionBasisSettingFields
      }
      fallback {
        ...CommissionBasisSettingFields
      }
    }
  }
  ${PRODUCTFEESETTING_FIELDS_FRAGMENT}
  ${PRODUCTPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${RETURNSSETTING_FIELDS_FRAGMENT}
  ${SHIPPINGPERCENTAGESETTING_FIELDS_FRAGMENT}
  ${PRODUCTREVIEWSETTING_FIELDS_FRAGMENT}
  ${COMMISSIONBASISSETTING_FIELDS_FRAGMENT}
`;
//# sourceMappingURL=fragments.js.map